import React, { useEffect, useState } from "react";
import {  Badge, Avatar, Dropdown, Popover, Alert,  } from "antd";
import { GoBellFill } from "react-icons/go";
import { FaBars, FaEllipsisV, FaUser, FaSignOutAlt } from "react-icons/fa";
import { AiFillCaretDown } from "react-icons/ai";
import { Layout, Row, Col, Button, Typography } from "antd";
import { ImageUrl } from "../../config/helpers";
import { useNavigate } from "react-router-dom";
import LogoutModal from "../../modals/LogoutModal";
import { useDispatch, useSelector } from "react-redux";
import { NOTIFICATIONS, UPLOADS_URL } from "../../config/constants/api";
import socket from "../../config/socket";
import { Get } from "../../config/api/get";
import { setCount } from "../../redux/slice/notificationSlice";

const { Header } = Layout;

const ClientHeader = ({ visible, setVisible, visible2, setVisible2 }) => {
  const dispatch = useDispatch();
  const [logoutModal, setLogoutModal] = useState(false);
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const notificationsCount = useSelector((state) => state.notification.count);
  const navigate = useNavigate();
  const [latestNotifications, setLatestNotifications] = useState(null);

  useEffect(() => {
    getAllNotifications();
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    socket.on("notification", (data) => {
      getAllNotifications();
    });
    return () => {
      socket.off("notification");
    };
     // eslint-disable-next-line 
  }, []);
  const getAllNotifications = () => {
    Get(NOTIFICATIONS.getAllAdminNotifications, token, {
      page: "1",
      limit: "3",
      isRead: false,
    })
      .then((response) => {
        if (response?.status) {
          setLatestNotifications(response?.data?.notifications?.docs);
          dispatch(setCount(response?.data?.unreadCount));
        }
      })
      .catch((err) => {
        console.log("Error fetching notifications ", err);
      });
  };
  
  const items = [
    {
      key: "1",
      label: (
        <div
          className="headerDropdown"
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            padding: "5px 12px",
          }}
          onClick={() => navigate("/profile")}
        >
          <FaUser style={{ fontSize: "16px" }} /> &nbsp; My Profile
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            padding: "5px 12px",
          }}
          onClick={() => setLogoutModal(true)}
        >
          <FaSignOutAlt style={{ fontSize: "16px" }} />
          &nbsp; Logout
        </div>
      ),
    },
  ];

  const content = (
    <div style={{ width: "350px" }}>
      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>Notifications</h3>
        <Alert
          message={`${notificationsCount} New`}
          type="success"
          style={{ fontSize: "12px", padding: "2px 10px", color: "green" }}
        />
      </div>
      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />
      <div style={{ height: "250px", overflow: "auto" }}>
        {latestNotifications &&
          latestNotifications.length > 0 &&
          latestNotifications.map((item) => {
            return (
              <div
              style={{
                padding: 10,
                minHeight: "100px",
                borderBottom: "1px solid #dadada",
                marginBottom: "5px",
                cursor: 'pointer'
              }}
              onClick={() => {
                if (item.payload.serviceType) {
                navigate("/reservationRequests");
                }
              }}
              >
              <Row
                style={{
                flexDirection: "row",
                justifyContent: "space-between",
                }}
              >
                <Col xs={4}>
                <div
                  style={{
                  display: "flex",
                  width: "40px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "40px",
                  backgroundColor: "#d7b65d",
                  borderRadius: "5px",
                  }}
                >
                  <GoBellFill
                  style={{ fontSize: "20px", color: "#fff" }}
                  />
                </div>
                </Col>
                <Col xs={20}>
                <Typography.Title
                  className="font-euclid"
                  style={{ fontSize: "12px", color: "black", margin: 0 }}
                >
                  {item.title}
                </Typography.Title>

                <Typography.Text
                  className="font-euclid"
                  style={{ fontSize: "11px", color: "rgb(44 34 34)", margin: 0 }}
                >
                  {item?.content?.slice(0, 100)}{" "}
                  {item.content.length > 100 && "..."}
                </Typography.Text>
                </Col>
              </Row>
              </div>
            );
          })}
      </div>

      <hr
        style={{
          borderLeft: "none",
          borderBottom: "none",
          borderRight: "none",
          borderTop: "1px solid rgb(0 0 0 / 15%)",
        }}
      />

      <div
        style={{
          padding: "10px 20px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Button type="link" onClick={() => navigate("/recentNotifications")}>
          View All
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <Row>
        <Col xs={0} md={24}>
          <Header
            className="header"
            style={{
              height: "12vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "25px 60px",
              boxShadow: " 0 0 0 1px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Popover
                content={content}
                placement="bottomRight"
                arrow={false}
                className="headerPopover"
              >
                <Badge
                  count={notificationsCount}
                  style={{ backgroundColor: "red" }}
                >
                  <GoBellFill style={{ fontSize: "25px", color: "#333d47" }} />
                </Badge>
              </Popover>
              &emsp; &emsp;
              <Avatar
                size={40}
                src={!userData.image ? ImageUrl("avatar.png") : UPLOADS_URL + userData.image}
                // src={ImageUrl("profile.png")}
              />
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                placement="bottomRight"
              >
                <p
                  style={{
                    marginLeft: 10,
                    color: "#333d47",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                  className="flex justify-center items-center font-euclid uppercase"
                >
                  Tom Felix
                  {/* {user?.firstName + " " + user?.lastName}{" "} */}
                  <AiFillCaretDown
                    fontSize={12}
                    style={{ color: "#333d47" }}
                  />{" "}
                </p>
              </Dropdown>
            </div>
          </Header>
        </Col>
      </Row>

      <Row>
        <Col xs={24} md={0}>
          <Header
            className="header"
            style={{
              height: "10vh",
              backgroundColor: "#333d47",
              display: "flex",
              alignItems: "center",
              padding: "15px 35px",
            }}
          >
            <Row
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaEllipsisV
                  style={{ fontSize: 22, color: "#333d47" }}
                  onClick={() => setVisible2(!visible2)}
                />
              </Col>
              <Col>
                <a href={"/"}>
                  <img
                    preview={false}
                    alt="Failed to load"
                    src={ImageUrl("logo.png")}
                    className="max-md:w-[60px]"
                  />
                </a>
              </Col>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaBars
                  style={{ fontSize: 22, color: "#333d47" }}
                  onClick={() => setVisible(!visible)}
                />
              </Col>
            </Row>
          </Header>
        </Col>
      </Row>

      {logoutModal && (
        <LogoutModal
          logoutModal={logoutModal}
          setLogoutModal={setLogoutModal}
        />
      )}
    </>
  );
};

export default ClientHeader;
